// extracted by mini-css-extract-plugin
export var actionButton = "_kk-t";
export var buttonContainer = "_kk-0";
export var buttonContainer2 = "_kk-1";
export var buttonSection = "_kk-2";
export var details = "_kk-3";
export var dropdownItem = "_kk-5";
export var dropdownItemsContainer = "_kk-4";
export var fileInput = "_kk-r";
export var headerButton = "_kk-6";
export var icon = "_kk-7";
export var input = "_kk-8";
export var macroListItem = "_kk-9";
export var mainContent = "_kk-a";
export var microText = "_kk-b";
export var modal = "_kk-w";
export var optionsButton = "_kk-c";
export var paperclip = "_kk-s";
export var pillContent = "_kk-d";
export var preview = "_kk-e";
export var preview2 = "_kk-f";
export var quillEditor = "_kk-q";
export var selectedMacro = "_kk-g";
export var sidebar = "_kk-h";
export var sidebarHeader = "_kk-j";
export var sidebarList = "_kk-i";
export var sidebarListItem = "_kk-k";
export var sidebarSearch = "_kk-l";
export var snoozeDurationWrapper = "_kk-v";
export var statusPillContainer = "_kk-m";
export var tagsContainer = "_kk-n";
export var unselectedMacro = "_kk-o";
export var variable = "_kk-u";
export var wrapper = "_kk-p";